<template>
  <div
    :class="`agreement ${marginT ? 'marginT' : ''}`"
    :style="{ height: marginT ? 'auto !important' : `${height}px` }"
    ref="agreement"
  >
    <!--    <div v-html="info.content" class="content"></div>-->
    <!--    <div class="content">-->
    <!--      <div class="title">{{ info.content.header }}</div>-->
    <!--      <ul>-->
    <!--        <li-->
    <!--          v-for="(item, idx) in info.content.text"-->
    <!--          :key="idx"-->
    <!--          :class="dealTextClass(item.trim())"-->
    <!--        >-->
    <!--          {{ item.split('|')[1] || item }}-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
    <component :is="type" />
  </div>
</template>

<script>
// import { AGREEMENT_CONFIG } from '@/config/agreement';

export default {
  name: 'Agreement',

  mixins: [],

  components: {
    user: () => import('./User.vue'),
    privacy: () => import('./Privacy'),
    hwUser: () => import('./hwUser'),
  },

  props: {},

  data() {
    return {
      type: '',
      info: {},
      AGREEMENT_ENUM: Object.freeze({
        user: '用户协议',
        privacy: '隐私政策',
        hwUser: '会员服务协议',
      }),
      marginT: false,
    };
  },

  computed: {
    height() {
      return (
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      );
    },
  },

  watch: {},

  created() {
    this.initRouteData();
  },

  mounted() {},

  destroyed() {},

  methods: {
    initRouteData() {
      this.type = this.$route.query.aType;
      this.marginT = Number(this.$route.query.marginTop) === 1;
      // this.info = Object.freeze(AGREEMENT_CONFIG[this.type]);
      document.title = this.AGREEMENT_ENUM[this.type] || '协议';

      if (this.marginT) {
        this.setHtmlHeight();
      }
    },
    dealTextClass(text) {
      return {
        h1: /([一二三四五六七八九十]、)/.test(text),
        h2: /(（[一二三四五六七八九十]）)/.test(text),
        h3: /\d、/.test(text) || /\d,\d/.test(text),
        h4: /(（\d）)/.test(text),
        p: text.includes('p|'),
      };
    },
    setHtmlHeight() {
      document.querySelector('html').style.height = 'auto';
      document.querySelector('html').style.overflowY = 'scroll';
      document.querySelector('body').style.height = 'auto';
      document.querySelector('#app').style.height = 'auto';

      this.$nextTick(() => {
        this.$refs.agreement.style.height = 'auto !important';
      });
    },
  },
};
</script>

<style lang="less" scoped>
.agreement {
  width: 100%;
  overflow-y: auto;
  padding: 17px 16px;
  box-sizing: border-box;
}

.marginT {
  margin-top: 82px;
}

.content {
  flex: 1;
  overflow-y: auto;
  text-align: left;
  background: #fff;
  .title {
    font-size: 22px;
    text-align: center;
    margin-bottom: 16px;
  }
  ul {
    width: 100%;
    li {
      width: 100%;
      font-size: 15px;
      line-height: 22px;
      color: #333;
      &.p {
        text-indent: 2em;
        font-size: 12px;
      }
      &.h1 {
        margin-top: 20px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
      }

      &.h3 {
        text-indent: 2em;
      }
      &.h4 {
        text-indent: 2em;
      }

      &.h2,
      &.h3,
      &.h4 {
        font-size: 12px;
        font-weight: 400;
      }

      &.h2 + .p,
      &.h3 + .p,
      &.h4 + .p {
        font-size: 12px;
      }
    }
  }
}
</style>
